
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/tools/creatives",
      function () {
        return require("private-next-pages/[locale]/tools/creatives/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/tools/creatives"])
      });
    }
  